import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionBox',
  props: {
    buttonLabel: { default: "" },
    title: { default: "" },
    description: { default: "" },
    icon: { default: "" }
  },
  emits: ["onRetry", "onUpload"],
  setup(__props: any, { emit: emits }) {





const onActionButtonClick = () => {
  emits("onRetry");
};

return { __sfc: true,emits, onActionButtonClick }
}

})